import { IconType } from "react-icons";
import { BsInstagram, BsTwitterX, BsWhatsapp, BsYoutube } from "react-icons/bs";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { FiMail, FiPhone } from "react-icons/fi";

export type SocialIconsKey =
  | "instagram"
  | "facebook"
  | "twitter"
  | "whatsapp"
  | "youtube"
  | "linkedin"
  | "mail"
  | "phoneNumber"
  | "email";

export const socialIconsMap: { [key in SocialIconsKey]: IconType } = {
  instagram: BsInstagram,
  facebook: FaFacebookF,
  twitter: BsTwitterX,
  whatsapp: BsWhatsapp,
  youtube: BsYoutube,
  linkedin: FaLinkedinIn,
  mail: FiMail,
  email: FiMail,
  phoneNumber: FiPhone,
};

export const socialShareOptions = [
  {
    name: "Facebook",
    icon: socialIconsMap["facebook"],
    generateLink: (url: string) =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    color: "#1d77f2",
  },
  {
    name: "X",
    icon: socialIconsMap["twitter"],
    generateLink: (url: string, title: string) =>
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
    color: "#000000",
  },
  {
    name: "Whatsapp",
    icon: socialIconsMap["whatsapp"],
    generateLink: (url: string, title: string) =>
      `https://api.whatsapp.com/send?text=${encodeURIComponent(`${title} ${url}`)}`,
    color: "#26d366",
  },
  {
    name: "LinkedIn",
    icon: socialIconsMap["linkedin"],
    generateLink: (url: string) =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    color: "#1789d1",
  },
  {
    name: "Email",
    icon: socialIconsMap["mail"],
    generateLink: (url: string, title: string) => {
      const subject = `Check out this article: ${title}`;
      const body = `Here is a link to an article I thought you might be interested in: ${url}`;
      return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    },
    color: "",
  },
];

export const channels = {
  te: {
    telegram: "https://t.me/dummy_ml_channel",
    whatsapp: "https://whatsapp.com/channel/0029Va9b1W70VycEcAG3Zi0I",
  },
  en: {
    telegram: "https://t.me/dummy_en_channel",
    whatsapp: "https://whatsapp.com/channel/0029Va9b1W70VycEcAG3Zi0I",
  },
  "te-IN": {
    telegram: "https://t.me/dummy_ml_channel",
    whatsapp: "https://whatsapp.com/channel/0029Va9b1W70VycEcAG3Zi0I",
  },
  "en-IN": {
    telegram: "https://t.me/dummy_en_channel",
    whatsapp: "https://whatsapp.com/channel/0029Va9b1W70VycEcAG3Zi0I",
  },
};
